import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class WorksStaffPaymentRatesNormsApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS, {
			entity: 'works_staff_payment_rates_norms',
		})
	}
}
